export default "__VITE_ASSET__Ced2KF6f__"